<template>
    <el-dialog :title="oauthClientTitle" width="45%" :visible.sync="isVisible" :before-close="closeDialog" v-loading="loading" element-loading-text="请稍等···">
        <el-form :model="oauthClientInfo" :rules="rules" ref="oauthClientInfo" label-width="100px">
            <el-form-item label="应用Id" prop="appId" v-if="oauthClientOperate === 'add'">
                <el-col :span="22">
                    <el-input v-model="oauthClientInfo.appId" placeholder="请输入应用Id" :disabled="!isEditable"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="应用Id" prop="appId" v-if="oauthClientOperate === 'edit'">
                <el-col :span="22">
                    <el-input v-model="oauthClientInfo.appId" :disabled="!isEditable"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="应用Key" prop="appKey" v-if="oauthClientOperate === 'add'">
                <el-col :span="22">
                    <el-input v-model="oauthClientInfo.appKey" placeholder="请输入应用Key" :disabled="!isEditable"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="应用Key" prop="appKey" v-if="oauthClientOperate === 'edit'">
                <el-col :span="22">
                    <el-input v-model="oauthClientInfo.appKey" placeholder="请输入应用Key"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="用户名" prop="adminName" v-if="oauthClientOperate === 'add'">
                <el-col :span="22">
                    <el-input v-model="oauthClientInfo.adminName" placeholder="请输入管理员用户名" :disabled="!isEditable"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="用户名" prop="adminName" v-if="oauthClientOperate === 'edit'">
                <el-col :span="22">
                    <el-input v-model="oauthClientInfo.adminName" placeholder="请输入管理员用户名"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="密码" prop="adminPassword" v-if="oauthClientOperate === 'add'">
                <el-col :span="22">
                    <el-input v-model="oauthClientInfo.adminPassword" placeholder="请输入管理员密码" :disabled="!isEditable"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="密码" prop="adminPassword" v-if="oauthClientOperate === 'edit'">
                <el-col :span="22">
                    <el-input v-model="oauthClientInfo.adminPassword" placeholder="请输入管理员密码"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="扩展参数" prop="extJson" v-if="oauthClientOperate === 'add'">
                <el-col :span="22">
                    <el-input v-model="oauthClientInfo.extJson" placeholder="请输入扩展参数"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="扩展参数" prop="extJson" v-if="oauthClientOperate === 'edit'">
                <el-col :span="22">
                    <el-input v-model="oauthClientInfo.extJson" placeholder="请输入扩展参数"></el-input>
                </el-col>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog()">取消</el-button>
            <el-button type="primary" @click="handleSubmit()">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
  props: ['oauthClientInfo', 'oauthClientTitle', 'oauthClientOperate'],
  data() {
    return {
      isVisible: true,
      loading: false,
      rules: {
        appId: [{ required: true, message: '请输入应用Id', trigger: 'blur' }],
        appKey: [{ required: true, message: '请输入应用Key', trigger: 'blur' }],
        adminName: [{ required: true, message: '请输入管理员用户名', trigger: 'blur' }],
        adminPassword: [{ required: true, message: '请输入管理员密码', trigger: 'blur' }],
        extJson: [{ required: false, message: '请输入扩展参数', trigger: 'blur' }],
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.oauthClientInfo.validate((valid) => {
        if (valid) {
          if (this.oauthClientOperate === 'add') {
            const addParams = {
              appId: this.oauthClientInfo.appId,
              appKey: this.oauthClientInfo.appKey,
              adminName: this.oauthClientInfo.adminName,
              adminPassword: this.oauthClientInfo.adminPassword,
              extJson: this.oauthClientInfo.extJson,
            };
            this.oauthClientRequest('/console/configs/oauthClient/insert', addParams);
          } else if (this.oauthClientOperate === 'edit') {
            const editParams = {
              id: this.oauthClientInfo.id,
              appId: this.oauthClientInfo.appId,
              appKey: this.oauthClientInfo.appKey,
              adminName: this.oauthClientInfo.adminName,
              adminPassword: this.oauthClientInfo.adminPassword,
              extJson: this.oauthClientInfo.extJson,
            };
            this.oauthClientRequest('/console/configs/oauthClient/update', editParams);
          }
        }
      });
    },
    oauthClientRequest(url, params) {
      this.loading = true;
      this.$http.post(url, params).then(() => {
        this.$emit('oauth-client-success');
      })
      .catch(() => { this.$http.buildErrorHandler(`${url}请求失败！`); })
      .finally(() => {
        this.loading = false;
      });
    },
    closeDialog() {
      this.$emit('close-dialog');
    },
  },
  computed: {
    isEditable() {
      return this.oauthClientOperate !== 'edit';
    },
  },
};
</script>



// WEBPACK FOOTER //
// oauth_client_config_dialog.vue?5d15dc38